export const Action = {
  setGroupProfile: "setGroupProfile",
  clearGroupProfile: "clearGroupProfile",
  setGroupProfiles: "setGroupProfiles",
  clearGroupProfiles: "clearGroupProfiles",
  setInvitedGroup: "setInvitedGroup",
  clearInvitedGroup: "clearInvitedGroup",
};

export const Mutation = {
  SET_GROUP_PROFILE: "GRP_PROFILE",
  SET_GROUP_PROFILES: "GRP_PROFILES",
  SET_INVITED_GROUP: "INVITED_GROUP",
};
